import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=3711f9bb&scoped=true"
import script from "./Canvas.vue?vue&type=script&lang=js"
export * from "./Canvas.vue?vue&type=script&lang=js"
import style0 from "./Canvas.vue?vue&type=style&index=0&id=3711f9bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3711f9bb",
  null
  
)

export default component.exports